export default __webpack_public_path__ + "static/media/botHead2.55e4c263.png";